export type LogResult = {
  firstEventDate: string
  lastEventDate: string
  viewCount: number
  title: string | null
  url: string
	service: string
	serviceId: string | null
	clientName: string | null
	tags: {
		department: string[]
		drug: string[]
		disease: string[]
		other: string[]
	}
}

export type LogResultList = {
	list: LogResult[]
}

export type TimesResult = {
  weekDay: number
  hour: number
  count: number
}
export type TimesResultList = {
	list: TimesResult[]
}

export type ServicesResult = {
  service: string
  count: number
}
export type ServicesResultList = {
	list: ServicesResult[]
}

export type TagResultList = {
	tag: string
	count: number
}
export type TagStatsResult = {
	client: TagResultList[]
	department: TagResultList[]
	drug: TagResultList[]
	disease: TagResultList[]
	other: TagResultList[]
}

export type LogCondition = {
	service?: string[]
	weekDay?: string[]
	hour?: number[]
	days?: number
}

export const Hours = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', 
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'
]
